// extracted by mini-css-extract-plugin
export default {"container":"Offers_container__41+2J"};